var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciple5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.78 67.78L54.8533 54.8533M29 44.0811C29 46.0616 29.3901 48.0227 30.148 49.8524C30.9059 51.6821 32.0167 53.3447 33.4172 54.7451C34.8176 56.1455 36.4801 57.2563 38.3098 58.0142C40.1395 58.7721 42.1006 59.1622 44.0811 59.1622C46.0616 59.1622 48.0227 58.7721 49.8524 58.0142C51.6821 57.2563 53.3447 56.1455 54.7451 54.7451C56.1455 53.3447 57.2563 51.6821 58.0142 49.8524C58.7721 48.0227 59.1622 46.0616 59.1622 44.0811C59.1622 42.1006 58.7721 40.1395 58.0142 38.3098C57.2563 36.4801 56.1455 34.8176 54.7451 33.4172C53.3447 32.0167 51.6821 30.9059 49.8524 30.148C48.0227 29.3901 46.0616 29 44.0811 29C42.1006 29 40.1395 29.3901 38.3098 30.148C36.4801 30.9059 34.8176 32.0167 33.4172 33.4172C32.0167 34.8176 30.9059 36.4801 30.148 38.3098C29.3901 40.1395 29 42.1006 29 44.0811Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56.1255C36 54.6585 36.577 53.2515 37.6039 52.2142C38.6309 51.1769 40.0238 50.5941 41.4762 50.5941H46.9524C48.4048 50.5941 49.7977 51.1769 50.8246 52.2142C51.8516 53.2515 52.4286 54.6585 52.4286 56.1255M38.7381 39.5314C38.7381 40.9984 39.315 42.4053 40.342 43.4426C41.369 44.48 42.7619 45.0627 44.2143 45.0627C45.6667 45.0627 47.0596 44.48 48.0865 43.4426C49.1135 42.4053 49.6905 40.9984 49.6905 39.5314C49.6905 38.0644 49.1135 36.6574 48.0865 35.6201C47.0596 34.5828 45.6667 34 44.2143 34C42.7619 34 41.369 34.5828 40.342 35.6201C39.315 36.6574 38.7381 38.0644 38.7381 39.5314Z",
    stroke: "#008CB7",
    strokeWidth: 2.83048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple5);
export default __webpack_public_path__ + "static/media/Principle5.233cf824d5352759861c31d0bb7bbe0c.svg";
export { ForwardRef as ReactComponent };